/*
 * @FilePath: /kitchen-offline-web/src/3DEngine/render/specialHandler/topPanel.js
 * @Author: Yongchao Wang
 * @Date: 2021-07-21 13:35:42
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-03-11 13:46:12
 */

import { MeshBuilder } from '@babylonjs/core/Meshes/meshBuilder';
import { CSG } from '@babylonjs/core/Meshes/csg';
import { Texture } from '@babylonjs/core/Materials/Textures/texture';
import { PBRMaterial } from '@babylonjs/core/Materials/PBR/pbrMaterial';

import { Vector3 } from '@babylonjs/core/Maths/math';

class TopPanel {
  /**
   * @description: 初始化台面
   * @param {*} scene 场景
   * @param {*} position 中心点位置
   * @param {*} size 长宽高
   * @return {*}
   * @author: Yongchao Wang
   */
  constructor(scene, position, size, isRotation) {
    this.scene = scene;
    this.position = position;
    this.size = size;
    this.mesh = null;
    this.isRotation = isRotation;
  }

  createTopPanel(textureImage) {
    if (this.mesh) {
      this.mesh.dispose();
      this.scene.removeMesh(this.mesh);
      this.mesh = null;
    }
    const box = MeshBuilder.CreateBox('TableBoard', this.size, this.scene);
    this.mesh = box;
    box.position = new Vector3(
      this.position.x,
      this.position.y,
      this.position.z,
    );
    if (textureImage) {
      const myMaterial = this.getMaterial(textureImage);

      box.material = myMaterial;
    }
  }

  /**
   * @description: 台面挖洞
   * @param {*} holePosition 洞的位置
   * @param {*} holeSize 洞的尺寸
   * @param {*} textureImage 材质
   * @return {*}
   * @author: Yongchao Wang
   */
  createHoleTopPanel(holePosition, holeSize, textureImage) {
    const hole = MeshBuilder.CreateBox('Hole', holeSize, this.scene);
    hole.position = new Vector3(holePosition.x, holePosition.y, holePosition.z);
    const orginCSG = CSG.FromMesh(this.mesh);
    const holeCSG = CSG.FromMesh(hole);

    const resultCSG = orginCSG.subtract(holeCSG);
    const finnallyPipe = resultCSG.toMesh('finallyTopPanel', null, this.scene);
    if (textureImage) {
      const myMaterial = this.getMaterial(textureImage);
      finnallyPipe.material = myMaterial;
    }

    hole.dispose();
    this.mesh.dispose();
    this.scene.removeMesh(hole);
    this.scene.removeMesh(this.mesh);
    this.mesh = finnallyPipe;
  }

  /**
   * @description: 改变材质
   * @param {*} textureImage
   * @return {*}
   * @author: Yongchao Wang
   */
  async changeTexture(textureImage) {
    const myMaterial = await new Promise((resolve) => {
      this.getMaterial(textureImage, (material) => {
        resolve(material);
      });
    });
    this.mesh.material = myMaterial;
  }

  getMaterial(textureImage, onLoadComplete) {
    if (!this.mesh) {
      return undefined;
    }
    const textureUrl = this.isRotation
      ? `${textureImage}?x-oss-process=image/rotate,90`
      : textureImage;
    let myMaterial = this.mesh.material;
    if (myMaterial === null) {
      myMaterial = new PBRMaterial('myMaterial', this.scene);
      myMaterial.metallic = 0;
      myMaterial.roughness = 0.8;
      myMaterial.environmentIntensity = 0.4;
    }
    const texture = new Texture(
      textureUrl,
      this.scene,
      undefined,
      undefined,
      undefined,
      () => {
        texture.vScale = 1;
        texture.uScale = 1;
        myMaterial.albedoTexture = texture;

        if (onLoadComplete) {
          onLoadComplete(myMaterial);
        }
      },
    );

    return myMaterial;
  }
}

export default TopPanel;
